const INTERVAL_TIME = 500;
const TIMEOUT_TIME = 3000;

function getOpenQueryChecker() {
  const openQueries = new Set();
  let counter = 0;

  function checkOpenQueries(useTimeout = false, timeoutValue = TIMEOUT_TIME) {
    return new Promise(resolve => {
      const timeout = useTimeout
        ? setTimeout(() => {
            clearInterval(interval);
            clearTimeout(timeout);
            resolve();
          }, timeoutValue)
        : null;
      const interval = setInterval(() => {
        if (openQueries.size === 0) {
          clearInterval(interval);
          if (timeout) clearTimeout(timeout);
          resolve();
        }
      }, INTERVAL_TIME);
    });
  }

  function getRequestId() {
    counter += 1;
    return counter;
  }

  return {
    openQueries,
    checkOpenQueries,
    getRequestId
  };
}

export default getOpenQueryChecker;
